import React from 'react';
import OrmdOrderDetailShared from 'components/Tvendo/Sale/Operations/OrderWebMovil/OrdmOrderDetailShared';

export default function () {
  return <OrmdOrderDetailShared />;
}
